export default "__VITE_ASSET__CXlUlFoc__"